import './ToggleBtn.css';

// Styles for the toggle container and the toggle itself; the container ones
// also neutralise UA and global button styling now that it renders a <button>
const getStyles = (isOn, containerColor, toggleColor, width, height) => ({
  container: {
    width,
    height,
    borderRadius: `${parseInt(height, 10) / 2}px`,
    backgroundColor: containerColor,
    justifyContent: isOn ? 'flex-end' : 'flex-start',
    cursor: 'pointer',
    display: 'block',
    padding: 0,
    border: 'none',
    boxShadow: 'none',
  },
  toggle: {
    width: `${parseInt(height, 10) - 8}px`,
    height: `${parseInt(height, 10) - 8}px`,
    backgroundColor: toggleColor,
    transform: isOn ? `translateX(${parseInt(width, 10) - parseInt(height, 10)}px)` : 'none',
  },
});

// The Toggle component
function ToggleBtn({ isOn, onToggle, containerColor, toggleColor, size, ariaLabel }) {
  const styles = getStyles(isOn, containerColor, toggleColor, size.width, size.height);

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isOn}
      aria-label={ariaLabel}
      style={styles.container}
      className="container"
      onClick={onToggle}
    >
      <div style={styles.toggle} className="toggle" />
    </button>
  );
}

// Default props for the component
ToggleBtn.defaultProps = {
  containerColor: '#4CD964',
  toggleColor: '#FFFFFF',
  size: { width: '60px', height: '30px' },
};

export default ToggleBtn;
